'use client';

import { PROFILE_LOAD_BOARDS_PAGE_PATH } from '~/app/pages';
import NavLink from '~/app/(authenticated)/_ui/NavItems/NavLink';
import useIsActivePathname from '~/app/(authenticated)/_lib/useIsActivePath';

export default function ProfileLoadBoardsNavLink() {
  return (
    <NavLink
      href={PROFILE_LOAD_BOARDS_PAGE_PATH}
      label="Load Boards"
      active={useIsActivePathname(PROFILE_LOAD_BOARDS_PAGE_PATH)}
    />
  );
}
